// extracted by mini-css-extract-plugin
export default {"element":"CtaBox-module--element--ac58d","container":"CtaBox-module--container--522e9","link":"CtaBox-module--link--e61ed"};